<template>
    <!-- ----------------------------------- -->
    <!-- Navegació entre pantalles           -->
    <!-- ----------------------------------- -->
    <div
        class="d-flex flex-row justify-content-between align-items-center m-2 mt-5 mb-5"
        style="margin: auto;"
    >
        <button
            type="button"
            style="width: 30%"
            class="btn btn-outline-secondary p-2 text-center"
            @click="previous()"
        >
            <i class="fas fa-backward"></i>
        </button>
        <button
            type="button"
            class="btn btn-outline-secondary p-2"
            @click="clear()"
            style="width: 30%"
        >
            <i class="fas fa-undo"></i>
        </button>
        <button
            type="button"
            class="btn p-2"
            style="width: 30%"
            :class="
                app.currentConfiguration.validation.valid
                    ? 'btn-dark font-weight-bold'
                    : 'btn-outline-dark'
            "
            @click="next()"
        >
            <i v-if="app.isProcessing" class="fa fa-spinner fa-spin mr-2"></i>
            <i class="fas fa-forward"></i>
        </button>
    </div>
</template>
<script>
import { app } from "../../application.js";


export default {
    name: "genericConfiguratorComponent",

    data() {
        return {
            app: app,
        }
    },
    methods: {
        async previous() {
            await app.navigateToPreviousStage();
        },
        async clear() {
            let stage = parseInt(app.currentConfiguration.stage);

            switch (stage) {
                case 2:
                    await app.cleanP2Parameters();
                    break;
                case 3:
                    await app.cleanP3Parameters();
                default:
                    break;
            }
        },
        async next() {
            await app.navigateToNextStage();
        }
    }
}
</script>
